import CustomerInvoice from "./components/CustomerInvoice";

export default CustomerInvoice;
